import slice from 'lodash/slice';
import size from 'lodash/size';
import '../vendor/jquery/jquery.icontains';
import jQuery from 'jquery';
import translate from '../common/localization/translate';
import '../vcom/anlage';
import AlertService from '../common/alert/AlertService';
import ComponentSelectionService from './componentSelectionService';

export default function ComponentSelection(target) {
  const fn = {};
  let componentSelection;
  let elSelection;
  let elToggle;
  const MAX_SELECTED_DEVICE_COUNT = 15;
  const mpptChartsWithStandardSelection = ['HMSII'];

  fn.init = function init(target) {
    componentSelection = jQuery(target);
    elSelection = componentSelection.find('div.componentSelection');

    const activeCheckboxes = elSelection.find('form span:not(:hidden) div input[type=checkbox]');
    fn.colorize(activeCheckboxes.filter(':checked'));

    if (!elSelection[0]) {
      elSelection = jQuery('<div class="componentSelection">');
      componentSelection.append(elSelection);
    }

    elToggle = componentSelection.find('div.componentSelectionToggle');
    if (!elToggle[0]) {
      elToggle = fn.appendSlider(elSelection);
    }

    if (fn.selectionsExists()) {
      return this;
    }

    const html = fn.getSelectionHtml();
    elSelection.html(html);
    fn.bindlisteners(elSelection);
    return this;
  };

  fn.bindlisteners = function bindlisteners(elSelection) {
    // Dropdownfilter
    elSelection.on('change', 'select.Filter', fn.selectFilter);
    // Textfilter
    elSelection.on('keyup', 'input[name=textfilter]', fn.filterLabel);
    // Reset filter
    elSelection.on('click', 'button.showAll', fn.resetFilter);

    // Move to "selected" area or back to "unselected" area
    elSelection.on('click', 'form span', fn.moveToSelecteArea);

    // Buttons in Auswahl-Fieldset
    elSelection.on('click', 'button.selectAll', fn.selectAll);
    elSelection.on('click', 'button.selectNone', fn.unselectAll);
    elSelection.on('click', 'button.selectInverted', fn.invertSelection);

    elSelection.on('change', 'form span:not(:hidden) div input[type=checkbox]', fn.checkStringAmount);
  };

  fn.checkStringAmount = function () {
    if (fn.getTargetType() === 'Gak') {
      const maxStringAmount = 2000;
      if (fn.getStringAmountToDisplay() > maxStringAmount) {
        elSelection.find('form span:not(:hidden) div input[type=checkbox]:not(:checked)').prop('disabled', true);
        AlertService.showWarning(translate('javascript.MAX_STRING_AMOUNT'));
        return true;
      }
      elSelection.find('form span:not(:hidden) div input[type=checkbox]:not(:checked)').prop('disabled', false);
      return false;
    }
    return false;
  };

  fn.escapeSelector = function escapeSelector(id) {
    return id.replace(/(\.)/g, '\\$1');
  };

  fn.selectFilter = function selectFilter() {
    elSelection.find('input[name=textfilter]').val('');
    fn.filterAuswahl();
  };
  // Auswahl-Filter
  fn.filterAuswahl = function filterAuswahl() {
    const checkedOption = elSelection.find('select.Filter option:checked').val();

    if (checkedOption === 'selected') {
      elSelection.find('.textfilter').hide();
      elSelection.find('form span').hide();
      elSelection.find('form input[type=checkbox]:checked').parent().parent('span').show();
      return;
    }
    elSelection.find('.textfilter').show();
    if (checkedOption === 'all') {
      elSelection.find('form span').show();
      return;
    }

    elSelection.find('form span').hide();
    fn.unselectAll();
    const showSpans = `span.${fn.escapeSelector(checkedOption)}`;
    jQuery('fieldset form').find(showSpans).show();
    fn.selectAll();
  };
  fn.filterLabel = function filterLabel() {
    fn.filterAuswahl(); // reset Filter after every keyup

    const checkboxes = elSelection.find('form span:not(:hidden) div input');

    const textfilter = this.value;
    elSelection.find('form span').hide();

    checkboxes.parent().parent('span').filter(`:icontains('${textfilter}')`).show();
  };
  fn.resetFilter = function resetFilter() {
    elSelection.find('select.Filter option:first').prop('selected', true);
    elSelection.find('.textfilter').show();
    elSelection.find('input[name=textfilter]').val('');
    elSelection.find('form span').show();
  };

  // Draw Inverters and Inverter-Filter-Menu
  fn.loadStructure = function loadStructure(anlagenId) {
    const deferred = jQuery.Deferred();
    VCOM.anlage.getStructure(anlagenId, deferred.resolve);
    return deferred;
  };
  fn.natSortBy = (key) => (a, b) => {
    if (a[key] === undefined || b[key] === undefined) {
      return 0;
    }
    return a[key].localeCompare(b[key], undefined, { numeric: true });
  };
  fn.drawSelectableElements = function drawSelectableElements(structure, componentType) {
    const form = elSelection.find('form');
    form.empty();
    elSelection.find('#componentSelectionFilter option:gt(1)').remove();
    jQuery.each(structure.children, function () {
      const hasActiveInverterInputs = Array.isArray(this.children)
          && this.children.some((child) => child.isActive);
      if (!hasActiveInverterInputs && componentType === 'mppt') {
        return;
      }
      fn.expandStructureToDropdown(this, elSelection.find('select.Filter'));
      fn.expandStructureToSelection(this, form);
    });
    if (componentType === 'Wechselrichter' || componentType === 'mppt') {
      elSelection.find("#componentSelectionFilter option[value='Wechselrichter_unassignedGaks']").remove();
      elSelection.find('#unassignedGaks').remove();
    }
    if (componentType === 'Gak') {
      elSelection.find("#componentSelectionFilter option[value='Teilanlage_unassignedDevices']").remove();
    }
    const sortedInverter = form.find('span').sort(fn.natSortBy('innerText'));
    form.html(sortedInverter);
  };
  fn.expandStructureToDropdown = function expandStructureToDropdown(element, target) {
    if (element.type === 'Kuerzel' || element.type === fn.getTargetType() || element.type === 'DataDevice') {
      return;
    }

    const html = `<option value="${element.type}_${element.id}" class="${element.type}"> ${element.label} </option>\n'`;
    target.append(html);

    if (!element.children) {
      return;
    }
    jQuery.each(element.children, function () {
      fn.expandStructureToDropdown(this, target);
    });
  };
  fn.expandStructureToSelection = function expandStructureToSelection(element, target, parents) {
    parents = parents || '';

    if (element.type === 'VirtuellerWechselrichter') {
      element.type = 'Wechselrichter';
    }

    if (element.type === 'Kuerzel') {
      return;
    }

    if (element.type === fn.getTargetType()) {
      let stringAmountLabel = '';
      let stringAmountData = '';
      if (element.type === 'Gak') {
        const stringAmount = element.children ? element.children.length : 0;
        stringAmountData = `data-string-amount="${stringAmount}"`;
        stringAmountLabel = ` (${stringAmount} Strings)`;
      }
      const id = element.id.replace('.', '');
      const checkboxId = `checkbox-${id}`;
      let html = `<span id="${id}" class="${parents}">`;
      html += `<div class="custom-control custom-checkbox custom-control-inline">
        <input type="checkbox" class="custom-control-input" id="${checkboxId}" ${stringAmountData} name="element[]" value="${element.id}">
        <label class="custom-control-label" for="${checkboxId}">${element.label}${stringAmountLabel}</label>
      </span>\n`;
      target.append(html);
      return;
    }

    if (!element.children) {
      return;
    }
    jQuery.each(element.children, function () {
      fn.expandStructureToSelection(this, target, `${element.type}_${element.id} ${parents}`);
    });
  };

  // Buttons in Auswahl-Fieldset
  fn.selectAll = function () {
    const checkboxes = elSelection.find('form span:not(:hidden) div input[type=checkbox]');
    fn.select(checkboxes.filter(':not(:checked)'));
  };
  fn.unselectAll = function () {
    const checkboxes = elSelection.find('form span div input:checked');
    fn.unselect(checkboxes);
    fn.unColorize(checkboxes);
    elSelection.find('form span:not(:hidden) div input[type=checkbox]').prop('disabled', false);
  };
  fn.invertSelection = function () {
    const checkboxesChecked = elSelection.find('form span:not(:hidden) div input[type=checkbox]:checked');
    const checkboxesNotChecked = elSelection.find('form span:not(:hidden) div input[type=checkbox]:not(:checked)');

    fn.unselect(checkboxesChecked);
    fn.unColorize(checkboxesChecked);

    fn.select(checkboxesNotChecked);
  };
  // Bei onclick eines auswahlfeldes wird es hervorgehoben
  fn.moveToSelecteArea = function moveToSelecteArea(event) {
    let checkbox = jQuery(event.target);

    if (!checkbox.is('input[type=checkbox]')) { // click on text, not on checkbox
      checkbox = checkbox.find('input[type=checkbox]');
      if (!checkbox.is(':checked')) {
        fn.select(checkbox);
      } else {
        fn.unselect(checkbox);
      }
    }

    if (checkbox.is(':checked')) {
      fn.colorize(checkbox);
      return;
    }
    fn.unColorize(checkbox);
  };

  // Bei onclick eines ausgewählten auswahlfeldes wird es zurückgeschoben
  fn.moveToUnselectedArea = function moveToUnselectedArea(event) {
    const checkbox = jQuery(event.target).parent('div').find('input[type=checkbox]');
    const AuswahlCheckbox = fn.getAuswahlCheckboxes(checkbox);
    fn.unselect(AuswahlCheckbox);
    fn.unColorize(AuswahlCheckbox);
    fn.remove(checkbox);
  };

  // Hilfsfunktionen für Auswahl
  fn.select = function select(checkboxes) {
    checkboxes.each(function () {
      if (fn.checkStringAmount()) {
        return false;
      }
      const checkbox = jQuery(this);
      checkbox.prop('checked', true);
      fn.colorize(checkbox);
      return true;
    });
  };
  fn.unselect = function unselect(checkboxes) {
    checkboxes.prop('checked', false);
  };
  fn.colorize = function colorize(checkboxes) {
    checkboxes.parent().parent('span').addClass('component-colorized');
  };
  fn.unColorize = function unColorize(checkboxes) {
    checkboxes.parent().parent('span').removeClass('component-colorized');
  };
  fn.remove = function remove(checkboxes) {
    checkboxes.parent().parent('span').remove();
  };
  fn.getStringAmountToDisplay = function getStringAmountToDisplay() {
    return elSelection.find('form input[type=checkbox]:checked')
      .map((key, value) => jQuery(value).data('stringAmount'))
      .toArray()
      .reduce((total, num) => total + Math.round(num), 0);
  };
  fn.getAuswahlCheckboxes = function (checkboxes) {
    return fn.getCheckboxesInElement(checkboxes, 'form');
  };
  fn.getCheckboxesInElement = function getCheckboxesInElement(checkboxes, element) {
    const foundCheckboxes = [];
    jQuery(checkboxes).each(function () {
      const spanId = jQuery(this).parent('span').attr('id');
      const span = elSelection.find(`${element} span#${spanId}`);
      foundCheckboxes.push(span.find('input[type=checkbox]')[0]);
    });
    return jQuery(foundCheckboxes);
  };

  /**
   * @returns {String} html for component selection
   */
  fn.getSelectionHtml = function getSelectionHtml() {
    return `<fieldset class="Selection">
              <legend>${translate('javascript.TX_COMPONENTS')}</legend>
              <label for="componentSelectionFilter">${translate('javascript.TX_FILTER')}</label>
              <select id="componentSelectionFilter" class="Filter">
                    <option value="all">${translate('javascript.TX_ALL')}</option>
                    <option value="selected">${translate('javascript.TX_SELECTED')}</option>
              </select>
              <label for="componentSelectionTextfilter">${translate('javascript.TX_LABEL')}</label>
              <input type="text" id="componentSelectionTextfilter" name="textfilter">
              <button class="showAll">${translate('javascript.TX_SHOWALL')}</button><br><br>
              <fieldset class="Auswahl">
              <legend>${translate('javascript.TX_ELEMENTSELECTION')}</legend>
              <button class="selectAll">${translate('javascript.TX_SELECT_ALL')}</button>
              <button class="selectNone">${translate('javascript.TX_DESELECT_ALL')}</button>
              <button class="selectInverted">${translate('javascript.TX_INVERT')}</button><br><br>
            <form></form>
            </fieldset>
            <button class="show">${translate('javascript.TX_UPDATEGRAPH')}</button>
            </fieldset>`;
  };
  // Selection slides down from top of portlet
  fn.getSliderHtml = function getSliderHtml() {
    return '<div class="componentSelectionToggle"><div class="selectIcon showIcon"></div></div>';
  };
  fn.showSliderToHide = function showSliderToHide() {
    elToggle.find('.selectIcon').removeClass('showIcon').addClass('hideIcon');
  };
  fn.showSliderToShow = function showSliderToShow() {
    elToggle.find('.selectIcon').removeClass('hideIcon').addClass('showIcon');
  };
  fn.appendSlider = function appendSlider(elSelection) {
    const slider = jQuery(fn.getSliderHtml()).on('click', fn.toggle);
    elSelection.after(slider);
    return slider;
  };
  fn.toggle = function toggle() {
    if (elSelection.is(':hidden')) {
      fn.showSelection();
    } else {
      fn.hideSelection();
    }
  };
  fn.showSelection = function showSelection() {
    componentSelection.show();
    elSelection.slideDown('slow');
    fn.showSliderToHide();
  };
  fn.hideSelection = function hideSelection() {
    elSelection.slideUp('slow');
    componentSelection.show();
    fn.showSliderToShow();
  };
  fn.setComponentSelection = async function setComponentSelection(
    anlage,
    checkboxArray,
    componentType,
  ) {
    await ComponentSelectionService.setComponentSelection(anlage, checkboxArray.split(','), componentType);
  };

  fn.selectionsExists = function selectionsExists() {
    return elSelection.find('fieldSet.Selection')[0];
  };

  // componentSelection is reInitalized every time it is called
  // global variables don't work, so save current ElementSelection into jQuery().data:
  fn.setAnlage = function setAnlage(anlagenId) {
    componentSelection.data('anlage', anlagenId);
  };
  fn.getAnlage = function getAnlage() {
    return componentSelection.data('anlage');
  };
  fn.setTargetType = function setTargetType(targetType) {
    if (targetType === 'mppt') {
      targetType = 'Wechselrichter';
    }
    componentSelection.data('targetType', targetType);
  };
  fn.getTargetType = function getTargetType() {
    return componentSelection.data('targetType');
  };
  fn.getDefaultSelection = function getDefaultSelection(componentType, chartKey) {
    if (componentType === 'mppt' && !mpptChartsWithStandardSelection.includes(chartKey)) {
      return 1;
    }
    return MAX_SELECTED_DEVICE_COUNT;
  };
  fn.init(target);
  return {
    initSelection: function initSelection(anlagenId, componentType) {
      fn.setAnlage(anlagenId);
      fn.setTargetType(componentType);

      const deferred = fn.loadStructure(anlagenId);
      deferred.then((structure) => {
        fn.drawSelectableElements(structure, componentType);
      });
      return deferred;
    },
    /**
     * Set callback function to react on form submit
     * @param function callback(event)
     */
    getSelected: function getSelection() {
      return elSelection.find('form input[type=checkbox]:checked')
        .map((key, value) => jQuery(value).val())
        .toArray()
        .join();
    },
    // bind extern callback to react on submit
    onSubmit: function onSubmit(callback) {
      elSelection.off('click', 'button.show');
      elSelection.on('click', 'button.show', callback);
    },
    showSelection: fn.showSelection,
    hideSelection: fn.hideSelection,
    setComponentSelection: fn.setComponentSelection,
    async preSelectComponents(anlage, componentType, chartKey) {
      const checkboxes = elSelection.find('form span div input[type=checkbox]');
      const wasPreselectionDone = chartKey !== 'HMSII'
        ? await (async () => {
          const getSelectedComponentsResponse = await ComponentSelectionService
            .getComponentSelection(anlage, componentType);
          if (getSelectedComponentsResponse.data.length > 0) {
            const checkboxesArray = elSelection.find('form input[type=checkbox]')
              .map((key, value) => jQuery(value).val())
              .toArray()
              .join()
              .split(',');
            const selectedComponents = getSelectedComponentsResponse
              .data.map((checkbox) => checkbox.CHECKBOX_ID);
            const toBeSelected = checkboxesArray
              .filter((item) => selectedComponents.includes(item));
            if (toBeSelected.length > 0) {
              document.querySelectorAll("input[type='checkbox']").forEach((checkbox) => {
                if (toBeSelected.includes(checkbox.value)) {
                  checkbox.checked = true;
                }
              });
              return true;
            }
          }
          return false;
        })()
        : false;

      if (!wasPreselectionDone) {
        jQuery(slice(checkboxes, 0, fn.getDefaultSelection(componentType, chartKey))).prop('checked', true);
      }
      elSelection.find('.show').trigger('click');
      if (size(checkboxes) > fn.getDefaultSelection(componentType, chartKey)) {
        fn.showSelection();
      }
    },
  };
}
